module.exports = __webpack_public_path__ + "672437d62073787f76b388502b7b886b.png";